(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7398],{

/***/ 8937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-account",
      function () {
        return __webpack_require__(71095);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47906);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39618);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var voca__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81209);
/* harmony import */ var _ColorPicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14857);
/* harmony import */ var _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8194);
/* harmony import */ var _DropdownInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61993);
/* harmony import */ var _FileInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40296);
/* harmony import */ var _PriceInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84456);
/* harmony import */ var _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33923);













const formElements = {
    FileInput: _FileInput__WEBPACK_IMPORTED_MODULE_10__/* .FileInput */ .S,
    DateTimeInput: _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__/* .DateTimeInput */ .Y,
    TextInput: _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o,
    PriceInput: _PriceInput__WEBPACK_IMPORTED_MODULE_11__/* .PriceInput */ .t,
    TextAreaInput: _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__/* .TextAreaInput */ .F,
    DropdownInput: _DropdownInput__WEBPACK_IMPORTED_MODULE_9__/* .DropdownInput */ .f,
    ColorPicker: _ColorPicker__WEBPACK_IMPORTED_MODULE_7__/* .ColorPicker */ .z
};
const INPUT_ELEMENTS = [
    "CheckboxInput",
    "DropdownInput"
];
const isProtectedInput = (element)=>{
    var ref, ref1;
    // if ((element.type as any).name === 'CheckboxInput') console.log({ element })
    if ((ref = element.props) === null || ref === void 0 ? void 0 : ref.isProtected) return true;
    if ((ref1 = element.type) === null || ref1 === void 0 ? void 0 : ref1.name) {
        return INPUT_ELEMENTS.includes(element.type.name);
    }
};
const getFormData = function(children, formData, setFormData) {
    let initialFormData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    children.forEach((element, i)=>{
        var ref;
        if ((element === null || element === void 0 ? void 0 : (ref = element.props) === null || ref === void 0 ? void 0 : ref.children) && !isProtectedInput(element)) {
            const { children: childElements  } = element.props;
            if (childElements) {
                const newChildren = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isArray)(childElements) ? [
                    ...childElements
                ] : [
                    childElements
                ];
                initialFormData = {
                    ...initialFormData,
                    ...getFormData(newChildren, formData, setFormData, initialFormData)
                };
                children[i] = children[i].type == _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...element.props,
                    children: newChildren
                }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    ...element.props,
                    children: newChildren
                }, i);
            }
        } else {
            var ref1;
            if (!(element === null || element === void 0 ? void 0 : (ref1 = element.props) === null || ref1 === void 0 ? void 0 : ref1.label)) return;
            const { label , required , onChange: existingOnChange  } = element.props;
            const camelCaseLabel = voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(label);
            // console.log({ camelCaseLabel })
            if (camelCaseLabel == null || camelCaseLabel === "") {
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i
                });
            } else {
                var ref2;
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i,
                    value: formData.hasOwnProperty(camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : "") ? (ref2 = formData[camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : ""]) === null || ref2 === void 0 ? void 0 : ref2.value : undefined,
                    onChange: (value, invalidData)=>{
                        const isInvalid = [
                            required && value === undefined,
                            invalidData
                        ].some((val)=>val === true);
                        // console.log({ isInvalid })
                        setFormData((currentFormData)=>({
                                ...currentFormData,
                                [camelCaseLabel]: {
                                    value: value,
                                    invalid: isInvalid
                                }
                            }));
                        existingOnChange && existingOnChange(value, invalidData);
                    }
                });
                initialFormData = {
                    ...initialFormData,
                    [camelCaseLabel]: {
                        value: undefined,
                        invalid: required === true
                    }
                };
            }
        }
    });
    return initialFormData;
};
/**
 * Primary UI component for Forms
 */ const Form = (param)=>{
    let { className , children , onSubmit , initialFormData , error , clearFormOnSubmit =false , clearFormOnError =false , clearForm , show =true , ...rest } = param;
    let modifiedChildren = [
        ...children
    ];
    const getInitialFormData = ()=>{
        if (initialFormData) {
            const normalizedFormData = Object.keys(initialFormData).reduce((acc, key)=>{
                acc[key] = {
                    value: initialFormData[key],
                    invalid: false
                };
                return acc;
            }, {});
            getFormData(modifiedChildren, normalizedFormData, ()=>{});
            return normalizedFormData;
        } else {
            return getFormData(modifiedChildren, {}, ()=>{});
        }
    };
    const [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(getInitialFormData());
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        if (!!clearForm) setFormData(getInitialFormData());
    }, [
        clearForm
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setFormData(getInitialFormData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setErrorMessage(error || "");
    }, [
        error
    ]);
    getFormData(modifiedChildren, formData, setFormData);
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const invalidForm = Object.values(formData).some((element)=>element.invalid);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        ...rest,
        className: className !== null && className !== void 0 ? className : "",
        onSubmit: async (e)=>{
            e.preventDefault();
            // console.log({ fd: Object.values(formData) })
            if (invalidForm) {
                setErrorMessage("One or more fields are invalid or missing");
                if (clearFormOnError) {
                    setFormData(getInitialFormData());
                }
                return;
            }
            if (onSubmit) {
                const formDataValues = Object.entries(formData).reduce((acc, param)=>{
                    let [key, value] = param;
                    return {
                        ...acc,
                        [voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(key)]: value.value
                    };
                }, {});
                const errorMessage = await onSubmit(formDataValues);
                if (errorMessage) {
                    setErrorMessage(errorMessage);
                }
            }
            if (clearFormOnSubmit) {
                setFormData(getInitialFormData());
            }
        },
        children: [
            modifiedChildren,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: !!errorMessage || !!invalidForm,
                ignoreTheme: true,
                className: "flex justify-center items-center text-center transition-all ".concat(errorMessage || invalidForm ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold mb-6 sm:mt-0 md:mt-8"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "One or more fields are invalid"
            })
        ]
    });
};


/***/ }),

/***/ 33923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ TextAreaInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);





/**
 * Primary UI component for text input
 */ const TextAreaInput = (param)=>{
    let { label , placeholder , value ="" , onChange , onKeyDown , className , rows , hint , validations , required , testid , show =true , labelBgColour , preventBorder =false , dynamicResize =false , preventResize =false , setError  } = param;
    const parsedValidations = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultValidations */ .C)(undefined, validations);
    let errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, parsedValidations);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        onLoad();
    }, []);
    const onLoad = ()=>{
        if (!show) return;
        handleDynamicResize();
    };
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (value === null) value = "";
    function handleDynamicResize(e) {
        if (dynamicResize && ref.current) {
            ref.current.style.height = "auto";
            ref.current.style.height = ref.current.scrollHeight + "px";
        }
    }
    function handleKeyDown(e) {
        onKeyDown && onKeyDown(e);
        if (e.isDefaultPrevented() && ref.current) ref.current.style.height = "auto";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col",
            className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute text-sm -translate-y-1/2 mb-2 ml-2 ".concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                style: {
                    backgroundColor: labelBgColour ? labelBgColour : theme.backgroundColour
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: required ? "after:content-['*'] after:mx-2 after:text-red-500" : "",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                required: required,
                value: value,
                onChange: (e)=>{
                    errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(e.target.value, parsedValidations);
                    // setErrorMessage(errorMsg ?? '')
                    const isInvalid = errorMessage !== "";
                    var ref;
                    if (!!setError) setError(errorMessage, (ref = testid !== null && testid !== void 0 ? testid : label) !== null && ref !== void 0 ? ref : "unknown");
                    onChange && onChange(e.target.value, isInvalid);
                    handleDynamicResize(e);
                },
                rows: rows !== null && rows !== void 0 ? rows : 3,
                autoComplete: "on",
                placeholder: placeholder,
                className: "transition-all bg-transparent ".concat(preventBorder ? "" : "border", " ").concat(errorMessage ? "text-red-500 border-red-500" : "", " ").concat(preventResize ? "resize-none" : "", " rounded px-4 py-4 text-sm outline-none"),
                "data-testid": testid !== null && testid !== void 0 ? testid : null,
                onKeyDown: handleKeyDown,
                ref: ref
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                children: hint
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ }),

/***/ 87028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const EmptyLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyLayout);


/***/ }),

/***/ 25875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ GoogleAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



const ADS_ENABLED = "false";
const DEBUG_MODE = false;
const GoogleAds = (param)=>{
    let { type , show =true , className =""  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        try {
            if (!show) return;
            if (true) {
                if (!window.adsbygoogle) window.adsbygoogle = [];
                window.adsbygoogle.push({});
                console.log({
                    ads: window.adsbygoogle
                });
            } else {}
        } catch (err) {
            if (DEBUG_MODE) console.log(err);
            else console.log("Ad Error Suppressed.");
        }
    }, []);
    if ((ADS_ENABLED === null || ADS_ENABLED === void 0 ? void 0 : ADS_ENABLED.toLowerCase()) !== "true" || !show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (type === "square") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                // display: 'inline-block',
                display: "block",
                // height: '90px',
                // width: '100%',
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "9657998552",
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
    if (type === "vertical") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                display: "inline-block",
                height: "100%",
                width: "300px",
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "3092590200",
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
    if (type === "horizontal") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                display: "inline-block",
                height: "90px",
                width: "100%",
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "2515404500",
            "data-ad-format": "inline",
            "data-full-width-responsive": "false"
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};


/***/ }),

/***/ 71095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CreateAccountPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./public/images/ForumLogoText.svg
var ForumLogoText = __webpack_require__(74561);
// EXTERNAL MODULE: ./public/images/ForummLogo.svg
var ForummLogo = __webpack_require__(63696);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/inputs/Form.tsx
var Form = __webpack_require__(26291);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./libs/GoogleAdsManager.tsx
var GoogleAdsManager = __webpack_require__(25875);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./libs/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(3830);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fc/index.esm.js
var fc_index_esm = __webpack_require__(81872);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/users/requestAccountCreation.ts

const REQUEST_ACCOUNT_CREATION = (0,_generated/* graphql */.B)("\n  mutation requestAccountCreation(\n    $firstName: String!\n    $lastName: String!\n    $email: String!\n  ) {\n    requestAccountCreation(\n      firstName: $firstName\n      lastName: $lastName\n      email: $email\n    ) {\n      success\n    }\n  }\n");

// EXTERNAL MODULE: ./components/base/GoogleTags.tsx
var GoogleTags = __webpack_require__(507);
;// CONCATENATED MODULE: ./components/authforms/SignUpForm.tsx





















const genericError = "Sorry, we couldn't create an account with that email. Please try again.";
const CAPTCHA_SITE_KEY = "6LcurR0sAAAAAKWR2i1LqTtVuLM1_Qy3TLi-WODP";
const SignUpForm = ()=>{
    var ref, ref1, ref2, ref3;
    const Captcha = esm/* default */.Z;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const { signInWithGoogle , signInWithLinkedIn , getHostedAuthenticatedUser , currentUser  } = (0,useAuth/* useAuth */.aC)();
    const router = (0,next_router.useRouter)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [completed, setCompleted] = (0,react.useState)(false);
    const [completedCaptcha, setCaptchaComplete] = (0,react.useState)(!CAPTCHA_SITE_KEY);
    const [errors, setErrors] = (0,react.useState)([]);
    const [isFirstLogin, setFirstLoginFlag] = (0,useLocalStorage/* default */.Z)("Forumm_FirstLogin", false);
    const [, setRedirectTarget] = (0,useLocalStorage/* default */.Z)("Forumm_redirect_target", undefined);
    const [requestAccountCreation] = (0,useMutation/* useMutation */.D)(REQUEST_ACCOUNT_CREATION);
    var ref4;
    const funnelIntent = (ref4 = (0,GoogleTags/* parseFunnelIntent */.z9)((ref = router.query) === null || ref === void 0 ? void 0 : ref.intent)) !== null && ref4 !== void 0 ? ref4 : "create_event";
    const requestedRedirect = typeof ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.redirect) === "string" ? router.query.redirect : "";
    const safeRedirect = requestedRedirect.startsWith("/") && !requestedRedirect.startsWith("//") ? requestedRedirect : "";
    const redirectPath = safeRedirect || (funnelIntent === "create_event" ? "/create-event" : "");
    const loginHref = {
        pathname: "/login",
        query: {
            intent: funnelIntent,
            ...redirectPath ? {
                redirect: redirectPath
            } : {}
        }
    };
    const redirectAfterLogin = ()=>{
        router.replace(isFirstLogin || funnelIntent === "create_event" ? "/create-event" : safeRedirect || "/dashboard");
    };
    const beginHostedSignIn = async (signIn)=>{
        setRedirectTarget({
            ...redirectPath ? {
                path: redirectPath
            } : {},
            analyticsIntent: funnelIntent
        });
        await signIn();
    };
    (0,react.useEffect)(()=>{
        if (currentUser) {
            redirectAfterLogin();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentUser
    ]);
    (0,react.useEffect)(()=>{
        if (!router.isReady || currentUser) return;
        getHostedAuthenticatedUser().then(()=>{
            redirectAfterLogin();
        }).catch(()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.isReady,
        currentUser
    ]);
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const isCleared = !message || message === "";
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    const handleSubmit = async (data)=>{
        setLoading(true);
        setErrors([]);
        try {
            var ref, ref1;
            const { email , firstName , lastName  } = data;
            if (!completedCaptcha) {
                setErrors((err)=>[
                        ...err,
                        {
                            step: "captcha",
                            message: "Please complete the CAPTCHA to proceed."
                        }
                    ]);
                setLoading(false);
                return;
            }
            const operationResult = await requestAccountCreation({
                variables: {
                    firstName,
                    lastName,
                    email
                }
            });
            if ((operationResult === null || operationResult === void 0 ? void 0 : operationResult.errors) || (operationResult === null || operationResult === void 0 ? void 0 : (ref = operationResult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.requestAccountCreation) === null || ref1 === void 0 ? void 0 : ref1.success) === false) {
                errorHandler("submit")(genericError, "submit");
                setLoading(false);
                return;
            }
            setFirstLoginFlag(true);
            setCompleted(true);
            setLoading(false);
        } catch (error) {
            console.log({
                catch: error
            });
            errorHandler("submit")(genericError, "submit");
            setLoading(false);
        }
    };
    if (completed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "w-4/5 sm:w-1/2 mt-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "flex flex-col space-y-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "text-center text-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-center mb-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ForummLogo/* default */.Z, {
                                        className: "block w-12 mr-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ForumLogoText/* default */.Z, {
                                        fill: theme.textColour,
                                        className: "h-6 w-24"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Please check your inbox"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "flex justify-center text-center mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "We've sent an email to the address you've provided. Click Set Password in that email to finish creating your account."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "text-sm flex space-x-2 justify-center mt-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: "text-link hover:underline",
                        href: loginHref,
                        children: "Back to Log in"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-col w-full max-w-2xl items-center justify-start min-h-full pb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-4/5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAdsManager/* GoogleAds */.M, {
                    type: "horizontal",
                    show: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-2 md:mt-4 w-full relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "flex flex-col items-center space-y-2 mb-3 lg:mb-5 max-w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "text-center text-xl sm:text-2xl cursor-pointer relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "relative mb-2 lg:mb-4 max-w-full flex items-center justify-center",
                                    onClick: ()=>window.location.href = "https://www.forumm.to",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForumLogoText/* default */.Z, {
                                        className: "h-9 sm:h-12 lg:h-14"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-extrabold max-w-full text-lg sm:text-2xl leading-tight",
                                    children: [
                                        "EVENTS FOR THE BOLD,",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " THE WEIRD AND THE BRILLIANT."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                            onSubmit: handleSubmit,
                            error: errors === null || errors === void 0 ? void 0 : (ref2 = errors[0]) === null || ref2 === void 0 ? void 0 : ref2.message,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mt-8 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "mb-4 grid grid-cols-2 gap-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>beginHostedSignIn(signInWithGoogle),
                                                    className: "flex h-9 items-center justify-center gap-2 rounded border border-slate-400 bg-white px-3 text-xs font-medium text-slate-800 transition-colors hover:bg-slate-50",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fc_index_esm/* FcGoogle */.JM8, {
                                                            className: "h-4 w-4"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Google"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>beginHostedSignIn(signInWithLinkedIn),
                                                    className: "flex h-9 items-center justify-center gap-2 rounded border border-slate-400 bg-white px-3 text-xs font-medium text-slate-800 transition-colors hover:bg-slate-50",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {
                                                            className: "h-4 w-4 text-[#0A66C2]"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "LinkedIn"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex items-center gap-3 text-xs text-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "h-px flex-1 bg-gray-300"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Quick sign up"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "h-px flex-1 bg-gray-300"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "grid grid-cols-1 sm:grid-cols-2 gap-0 sm:gap-3 mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            variation: "v2",
                                            className: "w-full mb-0",
                                            required: true,
                                            validations: {
                                                minLength: {
                                                    value: 2,
                                                    message: "First Name must be at least 2 characters"
                                                },
                                                maxLength: {
                                                    value: 70,
                                                    message: "First Name must be less than 70 characters"
                                                },
                                                pattern: {
                                                    value: /^[a-z ,.'-]+$/i,
                                                    message: "Name must consist of letters only"
                                                }
                                            },
                                            label: "First Name",
                                            placeholder: "First Name"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            variation: "v2",
                                            className: "w-full mb-0",
                                            required: true,
                                            validations: {
                                                minLength: {
                                                    value: 2,
                                                    message: "Last Name must be at least 2 characters"
                                                },
                                                maxLength: {
                                                    value: 70,
                                                    message: "Last Name must be less than 70 characters"
                                                },
                                                pattern: {
                                                    value: /^[a-z ,.'-]+$/i,
                                                    message: "Name must consist of letters only"
                                                }
                                            },
                                            label: "Last Name",
                                            placeholder: "Last Name"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                    variation: "v2",
                                    validations: {
                                        minLength: {
                                            value: 7,
                                            message: "Email must be at least 7 characters"
                                        },
                                        maxLength: {
                                            value: 70,
                                            message: "Email must be less than 70 characters"
                                        },
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Email must be valid"
                                        }
                                    },
                                    required: true,
                                    label: "Email",
                                    type: "email",
                                    placeholder: "your@email.com"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    show: !!CAPTCHA_SITE_KEY,
                                    className: "self-center mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Captcha, {
                                            className: "flex justify-center",
                                            sitekey: CAPTCHA_SITE_KEY,
                                            onChange: ()=>{
                                                setCaptchaComplete(true);
                                            },
                                            onError: ()=>{
                                                setCaptchaComplete(false);
                                            }
                                        }),
                                        errors.find((f)=>f.step === "captcha") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            ignoreTheme: true,
                                            textColour: "foregroundTextColour",
                                            className: "transition-all text-red-500 text-xs font-bold mt-1",
                                            children: (ref3 = errors.find((f)=>f.step === "captcha")) === null || ref3 === void 0 ? void 0 : ref3.message
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    variation: "v2",
                                    buttonType: "submit",
                                    className: "my-4 mt-5 w-full mb-0",
                                    title: "Sign-up",
                                    type: "primary",
                                    size: "large",
                                    loading: loading,
                                    textColor: "white"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "text-sm flex flex-wrap font-semibold gap-x-2 justify-center mt-2 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: "By signing up you agree to Forumm's"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                className: "text-[#ff00df] font-semibold hover:underline",
                                href: "/privacy",
                                children: "Privacy Policy"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "text-sm flex flex-wrap font-semibold gap-x-2 justify-center mb-4 mt-2 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: "Already have an account?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                className: "text-[#ff00df] font-semibold hover:underline",
                                href: loginHref,
                                children: "Sign-in Here"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var authforms_SignUpForm = (SignUpForm);

// EXTERNAL MODULE: ./layouts/EmptyLayout.tsx
var EmptyLayout = __webpack_require__(87028);
;// CONCATENATED MODULE: ./public/CircleMesh.png
/* harmony default export */ var CircleMesh = ({"src":"https://images-prod.forumm.to/3031/_next/static/media/CircleMesh.82e476bd.png","height":1600,"width":1600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAYFBMVEX+AN/+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN7+AN56pSwBAAAAIHRSTlMAAAEICwwNDxEUFRYXGBkbHB0eHyAhIiMkJicoKy06PAP56wIAAABCSURBVHjaBUCHEYAgDPy3h4AIKlFs+2/poS116wkire9jAiDNdz5MiKCek5UOQ3CB8cqgqNP6VbBRL4udIDHGtI8/eAkDPleN1poAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/Astronaut.png
/* harmony default export */ var Astronaut = ({"src":"https://images-prod.forumm.to/3031/_next/static/media/Astronaut.d2950ebf.png","height":1600,"width":1600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA3UlEQVR42mNABqnztsxLX7xjEohd+/QVE0Rw9mYwI23BNtnAyJb/SZPX/O388V8GJFZ56T4TQ8q0DWAFOWsOz06etO5v7voj/4sPXF4CEovNnwsxJXPxbpG8rSeWxTUvepq//dTT4gMX55RfuCsMluz+/Z8RbMK6w+n5205+KT1+/WHt7efRPAwMEN0x1XPAChQZGLhKj147XLjj3PHyM7eFQGJAmpEhqmwmWIGXaD5/3oajW0r2X95bdeWhFEis6tIDsBwYRBfOZC09di2//OTNirqHr8H21959wQgATm9gSHO2LcMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./pages/create-account.tsx








function CreateAccountPage() {
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        color: "backgroundColour",
        className: "min-h-screen w-screen relative overflow-x-hidden overflow-y-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex justify-center min-h-screen w-full items-start lg:items-center relative px-3 py-4 sm:px-6 sm:py-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "absolute bg-[#03fff5] size-full max-h-[70%] max-w-4/5 sm:max-w-5xl z-10 origin-left sm:translate-x-[15%] sm:translate-y-[-22%] sm:scale-x-150 translate-x-[4%] translate-y-[6%]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "absolute size-[130vh] translate-x-[40%] translate-y-[50%] right-0 bottom-0 z-20",
                    style: {
                        backgroundImage: "url(".concat(CircleMesh.src, ")"),
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "absolute bg-[#ff00df] size-full max-h-[70%] max-w-4/5 sm:max-w-5xl z-20 sm:translate-x-[5%] sm:translate-y-[-13%] translate-x-[2%] translate-y-[2%]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "absolute size-[100vh] translate-x-[40%] msd:translate-x-[40%] lwsg:translate-x-[25%] translate-y-[10%] right-0 bottom-0 z-40 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "absolute size-[100vh] animate-sway",
                        style: {
                            backgroundImage: "url(".concat(Astronaut.src, ")"),
                            backgroundSize: "100% 100%",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex justify-center items-start lg:items-center w-full max-w-5xl overflow-hidden bg-sky-500 relative z-50 min-h-[calc(100vh-2rem)] lg:min-h-0 lg:h-[min(95vh,820px)] pb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute bg-white size-full z-30 pb-2",
                            style: {
                                border: "3px solid #EBE064"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "w-full sm:w-11/12 md:w-4/5 z-50 px-4 py-5 sm:px-6 sm:py-6 flex justify-center items-start overflow-y-visible lg:overflow-y-auto relative min-h-full lg:h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(authforms_SignUpForm, {})
                        })
                    ]
                })
            ]
        })
    });
}
CreateAccountPage.Layout = EmptyLayout/* default */.Z;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,994,1458,9198,474,4555,1209,4853,788,9774,2888,179], function() { return __webpack_exec__(8937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);